
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import {PermissionManagerService} from "../services/permissionManager.seervice";
import {PermissionsFactory} from "../permissions.factory";
import {ModuleRolePermission} from "../models/moduleRolePermission";
import {PermissionBase} from "../permissionBase";

@Directive({
    selector: '[appIsGranted]'
})
export class IsGrantedDirective {
    private permissions: PermissionBase;
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionManagerS: PermissionManagerService
    ) { }

    @Input() set appIsGranted(permission: Array<string>) {
        this.isGranted(
            permission[0] as string,
            permission[1] as string
        );
    }
    private isGranted(resource: string, permissionType: string) {
        if (this.permissionManagerS.isGranted(resource, permissionType)) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }

    authAs(role: string) {
        localStorage.setItem('role', role);
        // localStorage.setItem('role',
        //     (role === null)
        //         ? Role.UNKNOWN
        //         : role
        // );
        this.permissions = PermissionsFactory.getInstance();
    }
}
